<script>
	import { topNavigationVisible } from '../share/stores';

	import BurgEinsLogo from '../images/BurgEinsLogo.svelte';
	import SmartLink from '../helpers/SmartLink.svelte';
	import HamburgerAndCloseButton from '../partials/HamburgerAndCloseButton.svelte';
	import NavListElement from '../helpers/NavListElement.svelte';

	document.addEventListener('click', () => {
		topNavigationVisible.set(false);
	});
</script>

<nav>
	<ul class="container">
		<li class="no-stretch" on:click|stopPropagation={() => topNavigationVisible.set(!$topNavigationVisible)}>
			<HamburgerAndCloseButton/>
		</li>
		<li class="stretch">
			<a href="/">
				<BurgEinsLogo/>
			</a>
		</li>
		<li class="visible--desktop">
			<ul>
				<NavListElement url="/portfolio" text="Portfolio"/>
				<NavListElement url="/agentur/kontakt" text="Kontakt"/>
				<NavListElement url="/agentur/jobs" text="Jobs"/>
			</ul>
		</li>
	</ul>
</nav>

<style lang="scss">
	@import "../style/variables";
	@import "../style/mixins";
	
	nav {
		height: auto;
		width: 100%;
		position: relative;
		background-color: white;
		
		ul.container {
			height: px-to-em(64);
			width: 100vw;
			//max-width: var(--max-main-width);
			position: relative;
			pointer-events: auto;
			list-style: none;
			display: flex;
			margin: auto;
			align-items: stretch;
			padding: 0 px-to-em(20);
			gap: px-to-em(30);
			
			@include for-tablet-landscape-up {
				padding: 0 px-to-rem(142);
			}
			
			@include for-desktop-up {
				height: px-to-em(122);
			}

			:global(li) {
				position: relative;
				list-style: none;
				flex: 1;
				margin: auto;
				width: auto;
			}


			:global(li:first-of-type) {
				cursor: pointer;
			}

			:global(li.stretch) {
				text-align: center;
				margin-left: -28px;

				@include for-tablet-landscape-up {
					display: block;
					flex-grow: 1;
					width: auto;
					margin-left: 0;
				}
			}

			:global(li.no-stretch) {
				flex-grow: 0;
				@include for-tablet-landscape-up {
					flex-grow: 1;
				}
			}

			:global(li.no-stretch div) {
				display: flex;
				gap: 2vw;
			}


			:global(li.visible--desktop) {
				display: none;

				@include for-tablet-landscape-up {
					display: block;
				}
			}

			:global(li ul) {
				display: flex;
				flex: auto;
				gap: 2vw;
				float: right;
			}

			:global(li ul li) {
				flex: auto;
			}

			:global(li ul li.active),
			:global(li ul li:hover) {
				color: #CCCCCC;
			}
		}

		:global(li svg) {
			vertical-align: middle;
		}

		:global(a), :global(p) {
			transition: color .2s ease-in-out;
			@include font-px-to-rem(20, 42, 400);

			@include for-big-desktop-up {
				@include font-px-to-rem(35, 55, 400);
			}
		}
	}
</style>
